import { storage, cloudFunction } from '../../config/firebaseConfig';

// SECTION 1: Adding or updating payment method
////////////////////////////////////////////////////////////////////////////////
export const openStripePaymentMethodModal = (coid) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "OPEN_STRIPE_PM_ACT",
            stripeSetupIntent: "",
            paymentMessage: "",
        });

        cloudFunction.httpsCallable('stripeGateway-createCustomerSetupIntent')({
            coid: coid
        })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "OPEN_STRIPE_PM_ACT",
                    stripeSetupIntent: res.data.isDoneAndSent ? res.data.responseMsg : "-1",
                    paymentMessage: res.data.isDoneAndSent ? "" : res.data.responseMsg,
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "OPEN_STRIPE_PM_ACT",
                    stripeSetupIntent: "-1",
                    paymentMessage: "Some internal error has occured!",
                });
            });
    }
}

export const attachPaymentMethodToCustomer = (coid, paymentMethodId) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "STRIPE_PM_ACTING"
        });

        cloudFunction.httpsCallable('stripeGateway-attachPaymentMethodToCustomer')(
            {
                coid: coid,
                paymentMethodId: paymentMethodId,
            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "STRIPE_PM_ACTED",
                    paymentMessage: res.data.responseMsg
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "STRIPE_PM_ACT_FAILED",
                    paymentMessage: "Payment method adding failed"
                });
            });
    }
}

export const changeCardDetailsOnStripe = (cardDetailsObject, coid) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "STRIPE_PM_ACTING"
        });

        cloudFunction.httpsCallable('stripeGateway-changeCardDetailsOnStripe')(
            {
                cardDetailsObject: cardDetailsObject,
                coid: coid,
            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "STRIPE_PM_ACTED",
                    paymentMessage: res.data.responseMsg
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "STRIPE_PM_ACT_FAILED",
                    paymentMessage: "Payment method updating failed"
                });
            });
    }
}

// SECTION 2: Purchasing a subscription or a product
////////////////////////////////////////////////////////////////////////////////
export const openStripeBuyProductModal = () => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "OPEN_STRIPE_PROD_ACT",
            requiresAction: false,
            stripePaymentIntent: "",
            buyProdActMessage: "",
        });
    }
}

export const customerBuyStripeSubscription = (productId, coid) => {
    const trialMinutes = undefined;
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "STRIPE_PROD_ACTING",
            stripePaymentIntent: "",
            buyProdActMessage: "",
        });

        cloudFunction.httpsCallable('stripeGateway-customerBuySubscription')(
            {
                productId: productId,
                coid: coid,
                trialMinutes: trialMinutes,
            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "STRIPE_PROD_ACTED",
                    stripePaymentIntent: res.data.requiresAction ? res.data.responseMsg : "-1",
                    buyProdActMessage: res.data.requiresAction ? "Manual action is required" : res.data.responseMsg,
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "STRIPE_PROD_ACT_FAILED",
                    stripePaymentIntent: "-1",
                    buyProdActMessage: `An unknown error has occurred: ${error}`
                });
            });
    }
}

export const confirmSubscriptionByOrder = (orderId, coid) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "STRIPE_PROD_ACTING",
            buyProdActMessage: "",
        });

        cloudFunction.httpsCallable('stripeGateway-confirmSubscriptionByOrder')(
            {
                orderId: orderId,
                coid: coid,
            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "STRIPE_PROD_ACTED",
                    buyProdActMessage: res.data.responseMsg,
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "STRIPE_PROD_ACT_FAILED",
                    buyProdActMessage: `An unknown error has occurred: ${error}`
                });
            });
    }
}

export const unsubOrder = (orderId, coid) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "STRIPE_PROD_ACTING"
        });

        cloudFunction.httpsCallable('stripeGateway-unsubOrder')(
            {
                orderId: orderId,
                coid: coid,
            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "STRIPE_PROD_ACTED",
                    buyProdActMessage: res.data.responseMsg
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "STRIPE_PROD_ACT_FAILED",
                    buyProdActMessage: `An unknown error has occurred: ${error}`
                });
            });
    }
}

export const requestOrderInvoice = (orderId, coid) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "STRIPE_PROD_ACTING"
        });

        cloudFunction.httpsCallable('stripeGateway-requestOrderInvoice')(
            {
                orderId: orderId,
                coid: coid,
            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "STRIPE_PROD_ACTED",
                    buyProdActMessage: res.data.responseMsg
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "STRIPE_PROD_ACT_FAILED",
                    buyProdActMessage: `An unknown error has occurred: ${error}`
                });
            });
    }
}

export const customerBuyConsumable = (productId) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "STRIPE_PROD_ACTING",
            stripePaymentIntent: "",
            buyProdActMessage: "",
        });

        cloudFunction.httpsCallable('stripeGateway-customerBuyConsumable')(
            {
                productId: productId,
            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "STRIPE_PROD_ACTED",
                    stripePaymentIntent: res.data.requiresAction ? res.data.responseMsg : "-1",
                    buyProdActMessage: res.data.requiresAction ? "Manual action is required" : res.data.responseMsg,
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "STRIPE_PROD_ACT_FAILED",
                    stripePaymentIntent: "-1",
                    buyProdActMessage: `An unknown error has occurred: ${error}`
                });
            });
    }
}

export const confirmConsumablePurchase = (conOrderId) => {
    return async (dispatch, getState) => {
        /// dispatch to indicate initiation of request
        dispatch({
            type: "STRIPE_PROD_ACTING",
            buyProdActMessage: "",
        });

        cloudFunction.httpsCallable('stripeGateway-confirmConsumablePurchase')(
            {
                conOrderId: conOrderId,
            })
            .then((res) => {
                /// dispatch to indicate successful request
                dispatch({
                    type: "STRIPE_PROD_ACTED",
                    buyProdActMessage: res.data.responseMsg,
                });
            }).catch((error) => {
                /// dispatch to indicate unsuccessful request
                dispatch({
                    type: "STRIPE_PROD_ACT_FAILED",
                    buyProdActMessage: `An unknown error has occurred: ${error}`
                });
            });
    }
}